<template>
    <div class="faqnavchild-box">
        <ul class="child-ul">
            <li class="child-li" :class='{isActive:index===type}' v-for='(item,index) in childnavData' :key='index' 
                @click='changeClick(index)'>{{item.name}}</li>
        </ul>
    </div>
</template>
<script>
    export default {
        name: 'FAQnavChild',
        data() {
            return {
                type: 0,
                childnavData: []
            }
        },
        mounted(){
            this.getChildNav()
        },
        methods: {
            isClick(num) {
                this.type = num
            },
            changeClick(num){
                this.$parent.pathTo(num)
                this.isClick(num)
            },
            getChildNav(){
                this.$axios.get(this.$API.thoreGetProblem)
                .then(res=>{
                    this.childnavData=res.data.data
                    // this.$parent.getChildItem(res.data.data)
                })
                .catch(err=>{
                    this.$message.error('网络波动，请刷新重试')
                })
            }
        }
    }
</script>
<style scoped>
    .child-li {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;


        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        color: #999999;
        padding-bottom: 24.5px;
        border-bottom: 1px solid #333333;
        transition: all 0.5s;
        position: relative;
        cursor: pointer;
    }

    .child-li:not(:first-child) {
        padding-top: 24.5px;
    }

    .child-li::after {
        content: '';
        height: 1px;
        width: 10px;
        background-color: #FFFFFF;
        position: absolute;
        top: 50%;
        right: 0%;
        transform: translateY(-50%);
    }

    .isActive {
        color: rgba(255, 255, 255, 1);
    }
    /* @media(max-width: 1023px){
        .faqnavchild-box{
            display: none;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/faq/faqnavchild.vue